<div class="assessment-content-container">
  <div class="assessment-header-cancel">
    <span
      (click)="close()"
      class="material-symbols-outlined assessment-close-icon"
      >close</span
    >
  </div>
  <div class="assessment-item-number">{{ data.itemNumber }}</div>
  <div class="mat-headline-4 assessment-title">{{ data.name }}</div>
  <div class="assessment-description">{{ data.description }}</div>
  <div class="assessment-help-tip">Help tip:</div>
  <div class="assessment-help-text">{{ data.helpTip }}</div>
</div>
